import { useMemo, useEffect, useState } from "react";
import { calculateDimensions } from "./utils/calculateDimensions";
import { calculateSrc } from "./utils/calculateSrc";
import { getFileName } from "../../functional/urlUtils";
import { useDebouncedEffect } from "../../functional/useDebounce";
export const useOptimizedSrc = ({ imageDimensions, containerDimensions, quality, pixelRatio, crop = false, offsetX, offsetY, fit = "width", url, }) => {
    const defaultSrc = `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>`;
    const imgWidth = imageDimensions?.width;
    const imgHeight = imageDimensions?.height;
    const containerWidth = containerDimensions?.width;
    const containerHeight = containerDimensions?.height;
    const [src, setSrc] = useState(defaultSrc);
    const [file, setStoredFile] = useState();
    const [storedHeight, setStoredHeight] = useState(undefined);
    const [storedWidth, setStoredWidth] = useState(undefined);
    const [desiredPixelRatio, setDesiredPixelRatio] = useState(pixelRatio || 1);
    useEffect(() => setDesiredPixelRatio(pixelRatio ?? window.devicePixelRatio ?? 1), [pixelRatio]);
    const originalAspectRatio = useMemo(() => {
        return imgWidth && imgHeight ? Math.round((imgWidth / imgHeight) * 100) / 100 : 0;
    }, [imgWidth, imgHeight]);
    const { desiredWidth, desiredHeight } = useMemo(() => {
        if (!desiredPixelRatio || !containerWidth || !containerHeight) {
            return {};
        }
        return calculateDimensions({
            containerWidth,
            containerHeight,
            imgHeight,
            imgWidth,
            desiredPixelRatio,
        });
    }, [containerWidth, containerHeight, imgHeight, imgWidth, desiredPixelRatio]);
    const optimizedSrc = useMemo(() => {
        if (!desiredWidth || !desiredHeight) {
            return undefined;
        }
        return calculateSrc({
            desiredWidth,
            desiredHeight,
            url,
            quality,
            crop,
            originalAspectRatio,
            offsetX,
            offsetY,
            fit,
        });
    }, [desiredWidth, desiredHeight, url, quality, crop, originalAspectRatio, offsetX, offsetY, fit]);
    useDebouncedEffect(() => {
        if (!desiredWidth || !desiredHeight || !optimizedSrc) {
            return;
        }
        if (!crop &&
            file === getFileName(url) &&
            ((storedWidth && desiredWidth && storedWidth > desiredWidth) ||
                (storedHeight && desiredHeight && storedHeight > desiredHeight))) {
            return;
        }
        else {
            setStoredFile(getFileName(url));
            setStoredHeight(desiredHeight);
            setStoredWidth(desiredWidth);
            setSrc(optimizedSrc);
        }
    }, [optimizedSrc, storedWidth, storedHeight, desiredWidth, desiredHeight, crop, src, file, url], 100);
    return src;
};
//# sourceMappingURL=hooks.js.map